const CarrierTerms = ({ children }) => {
    return <div className="carrier-terms">{children}</div>;
};

export default CarrierTerms;
